import { SVGProps } from 'react';
const SvgArrowDownLeftLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 5 5 19M13 19H5v-8"
    />
  </svg>
);
export default SvgArrowDownLeftLg;
